// extracted by mini-css-extract-plugin
module.exports = {"light":"UseCaseToggle_light__oB9UX","dark":"UseCaseToggle_dark__1ca9m"};